import { gql } from '@apollo/client'

export const SEARCH_DV_PRODUCTS = gql`
  query ($productName: String!, $configuration: ArtistProductType!) {
    searchProducts(productName: $productName, configuration: $configuration) {
      total
      products {
        dv_entity_id
        dv_group_id
        primaryArtistName
        name
        type
        release_date
      }
    }
  }
`
